export default __webpack_public_path__ + "static/media/ilustracion_disapproved.18f23fd1.svg";